// extracted by mini-css-extract-plugin
export default {"history-messages-skeleton":"styles_history-messages-skeleton__dS9lH","shimmer":"styles_shimmer__8yV+h"};